import {forwardRef, useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import LinkStores from '@adv-mt/mt-link-stores'
import SharedBrandLogo from '@adv-mt/mt-shared-brand-logo'

import {AdevintaLinks} from './adevinta-links.js'
import {BACKGROUND_COLORS, FOOTER_HEIGHTS} from './config.js'
import {GeneralLinks} from './general-links.js'
import {SocialMediaLinks} from './social-media-links.js'

const DESIGNS = {
  default: 'default',
  fullWidth: 'fullWidth'
}
function SharedCorporateFooter(
  {bgColor = BACKGROUND_COLORS.INHERIT, design = DESIGNS.default, isSimple = false, linkFactory},
  forwardedRef
) {
  const {domain, i18n} = useContext(Context)
  const domainConfig = domain.get('config')
  const brandUrl = domainConfig.get('HOME_URL')

  const baseClassName = cx('mt-SharedCorporateFooter', {
    'mt-SharedCorporateFooter--fullWidth': design === DESIGNS.fullWidth,
    'mt-SharedCorporateFooter--simple': isSimple,
    [`mt-SharedCorporateFooter--bg-${bgColor}`]: bgColor
  })

  return (
    <footer className={baseClassName} ref={forwardedRef}>
      {!isSimple ? (
        <>
          <div className="mt-SharedCorporateFooter-firstRow">
            <a className="mt-SharedCorporateFooter-logo" href={brandUrl}>
              <SharedBrandLogo />
            </a>
            <div className="mt-SharedCorporateFooter-appsLinks">
              <LinkStores hasShadow={false} />
            </div>

            <SocialMediaLinks />
          </div>
          <VisuallyHidden as="div" data-nosnippet role="heading" aria-level="2">
            {i18n.t('FOOTER.LINK.GENERAL_LINKS_HEADING')}
          </VisuallyHidden>
          <GeneralLinks linkFactory={linkFactory} />
        </>
      ) : null}
      <AdevintaLinks />
    </footer>
  )
}

SharedCorporateFooter.displayName = 'SharedCorporateFooter'
SharedCorporateFooter.propTypes = {
  bgColor: PropTypes.string,
  design: PropTypes.oneOf(Object.values(DESIGNS)),
  isSimple: PropTypes.bool,
  linkFactory: PropTypes.func
}

export {BACKGROUND_COLORS as sharedCorporateFooterBackgroundColors}
export {DESIGNS as sharedCorporateFooterDesigns}
export {FOOTER_HEIGHTS as sharedCorporateFooterHeights}
export default forwardRef(SharedCorporateFooter)
